<template>
    <div class="orderList-wrap">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap">
            <!-- <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">订单管理</span>
            </div> -->
            <el-tabs v-model="activeName"
                     type="card"
                     class="order-tabs"
                     @tab-click="handleTabClick">
                <el-tab-pane v-for="(item,index) in tabList" :key = index
                             :label= item.dictDataValue
                             :name= item.dictDataCode></el-tab-pane>
            </el-tabs>
            <div class="orderlist-content-wrap">
                <div class="select-form">
                    <div class="show-wrap">
                        <div class="search-show-wrap">
                            <el-input class="search-input"
                                    size="small"
                                    placeholder="请输入用户姓名"
                                    v-model="selectForm.name"
                                    @keyup.enter.native="searchOrder('search')">
                                <i slot="suffix"
                                class="iconfont icon-search"
                                @click="searchOrder('search')"></i>
                            </el-input>
                            <div class="more-search"
                                @click="isMoreShow=!isMoreShow">
                                <span class="more-search-text">高级搜索</span>
                                <i class="iconfont icon-drop_down"
                                :class="[{'is-reverse': isMoreShow}]"></i>
                            </div>
                        </div>
                        <el-button size="small"
                                type="primary"
                                @click="getExcel()">导出</el-button>
                    </div>
                    <div class="hide-wrap"
                        v-if="isMoreShow">
                        <div class="option-wrap">
                            <div class="option-item" v-if="activeName==='INCOME'">
                                <span class="label">订单类型</span>
                                <el-select v-model="selectForm.type"
                                        placeholder="请选择"
                                        size="small"
                                        :style="{width: '240px'}"
                                        @change="handleTypeChange">
                                    <el-option value="all"
                                            label="全部"></el-option>
                                    <el-option v-for="(item, index) in typeListTwo"
                                            :key="index"
                                            :label="item.dictDataValue"
                                            :value="item.dictDataCode">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="option-item" v-else>
                                <span class="label">订单类型</span>
                                <el-select v-model="selectForm.type"
                                        placeholder="请选择"
                                        size="small"
                                        :style="{width: '240px'}"
                                        @change="handleTypeChange">
                                    <el-option value="all"
                                            label="全部"></el-option>
                                    <el-option value="EXPERT_SEMINAR"
                                            label="医空间"></el-option>
                                </el-select>
                            </div>
                            <div class="option-item" v-if="activeName==='INCOME'">
                                <span class="label">订单状态</span>
                                <el-select v-model="selectForm.status"
                                        placeholder="请选择"
                                        size="small"
                                        :style="{width: '240px'}"
                                        @change="handleStatusChange">
                                    <el-option value="all"
                                            label="全部"></el-option>
                                    <el-option v-for="(item, index) in statusList"
                                            :key="index"
                                            :label="item.dictDataValue"
                                            :value="item.dictDataCode">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="option-item" v-else>
                                <span class="label">订单状态</span>
                                <el-select v-model="selectForm.status"
                                        placeholder="请选择"
                                        size="small"
                                        :style="{width: '240px'}"
                                        @change="handleStatusChange">
                                    <el-option value="all"
                                            label="全部"></el-option>
                                    <el-option v-for="(item, index) in statusListOut"
                                            :key="index"
                                            :label="item.dictDataValue"
                                            :value="item.dictDataCode">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="option-item" v-if="activeName==='INCOME'">
                                <span class="label">订单来源</span>
                                <el-select v-model="selectForm.sourceTag"
                                        placeholder="请选择"
                                        size="small"
                                        :style="{width: '240px'}"
                                        @change="handleSourceTagChange">
                                    <el-option value="all"
                                            label="全部"></el-option>
                                    <el-option v-for="(item, index) in consultFrom"
                                            :key="index"
                                            :label="item.valText"
                                            :value="item.val">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="option-item" v-if="activeName==='INCOME'">
                                <span class="label">优惠</span>
                                <el-input size="small"
                                        :style="{width: '240px'}"
                                        placeholder="请输入优惠"
                                        v-model.trim="selectForm.discountTag"
                                        @keyup.enter.native="searchOrder('search')">
                                </el-input>
                            </div>
                            <div class="option-item">
                                <span class="label">用户来源</span>
                                <el-select v-model="selectForm.origin"
                                        placeholder="请选择"
                                        size="small"
                                        :style="{width: '240px'}"
                                        @change="handleOriginChange">
                                    <el-option value="all"
                                            label="全部"></el-option>
                                    <el-option v-for="(item, index) in originList"
                                            :key="index"
                                            :label="item.dictDataValue"
                                            :value="item.dictDataCode">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="option-item">
                                <span class="label">支付时间</span>
                                <el-date-picker size="small"
                                                clearable
                                                clear-icon="el-icon-error"
                                                v-model="selectForm.buyTime"
                                                type="daterange"
                                                range-separator="-"
                                                start-placeholder="yyyy-mm-dd"
                                                end-placeholder="yyyy-mm-dd"
                                                value-format="yyyy-MM-dd"
                                                :style="{width: '240px'}"
                                                @change="handleDateChange"
                                                :picker-options="datePickerOptions"></el-date-picker>
                            </div>
                            <div class="select-btn-wrap">
                                <el-button type="primary"
                                        size="small"
                                        @click="searchOrder('search')">查询</el-button>
                                <el-button type="info"
                                        size="small"
                                        plain
                                        @click="searchOrder('reset')">重置</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-wrap">
                    <el-table :data="orderList"
                            stripe
                            v-loading="loading"
                            style="width: 100%">
                        <el-table-column prop="name"
                                        width="90px"
                                        type="index"
                                        label="序号">
                        </el-table-column>
                        <el-table-column prop="userName"
                                        min-width="110px"
                                        label="用户姓名">
                            <template slot-scope="scope">
                                {{scope.row.userName || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="userSource"
                                        min-width="80px"
                                        label="用户来源">
                            <template slot-scope="scope">
                                {{originList.find(origin =>origin.dictDataCode == scope.row.userSource)
                                    ? originList.find(origin =>origin.dictDataCode == scope.row.userSource).dictDataValue
                                    : '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderId"
                                        min-width="160px"
                                        label="订单编号">
                            <template slot-scope="scope">
                                {{scope.row.orderId || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderType"
                                        min-width="110px"
                                        label="订单类型">
                            <template slot-scope="scope">
                                {{typeList.find(type =>type.dictDataCode == scope.row.orderType)
                                    ? typeList.find(type =>type.dictDataCode == scope.row.orderType).dictDataValue
                                    : '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="sourceTag"
                                        v-if="activeName==='INCOME'"
                                        min-width="100px"
                                        label="订单来源">
                            <template slot-scope="scope">
                                {{scope.row.sourceTag|getScoreTag(consultFrom)}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="discountTag"
                                        v-if="activeName==='INCOME'"
                                        min-width="100px"
                                        label="优惠">
                            <template slot-scope="scope">
                                {{scope.row.discountTag || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="discountFee"
                                        v-if="activeName==='INCOME'"
                                        min-width="100px"
                                        label="优惠金额(元)">
                            <template slot-scope="scope">
                                {{scope.row.discountFee || '0'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="divideFee"
                                        v-if="activeName==='INCOME'"
                                        min-width="100px"
                                        label="收入金额(元)">
                            <template slot-scope="scope">
                                {{scope.row.divideFee || '0'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderFee"
                                        min-width="100px"
                                        label="订单费用(元)">
                            <template slot-scope="scope">
                                {{scope.row.orderFee || '0'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="refundFee"
                                        v-if="activeName==='INCOME'"
                                        min-width="100px"
                                        label="退款费用(元)">
                            <template slot-scope="scope">
                                {{scope.row.refundFee || '0'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="payTime"
                                        min-width="140px"
                                        label="支付时间">
                            <template slot-scope="scope">
                                {{scope.row.payTime|getDate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderStatus"
                                        min-width="100px"
                                        label="状态">
                            <template slot-scope="scope">
                                <span class="circle"
                                    :class="[{'success': scope.row.orderStatus=='SUCCESS' || scope.row.orderStatus=='REFUNDED'}]"></span>
                                <span>
                                    {{statusList.find(type =>type.dictDataCode == scope.row.orderStatus)
                                    ? statusList.find(type =>type.dictDataCode == scope.row.orderStatus).dictDataValue
                                    : '-'}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name"
                                        min-width="100px"
                                        fixed="right"
                                        label="操作">
                            <template slot-scope="scope">
                                <span class="link-btn"
                                    @click="goDetail(scope.row)">查看</span>
                            </template>
                        </el-table-column>
                        <div slot="empty"
                            class="table-none">
                            <div>
                                <svg-icon icon-class="none1" />
                            </div>
                            <span>暂无数据</span>
                        </div>
                    </el-table>
                </div>
                <div class="pagination-wrap">
                    <el-pagination background
                                @current-change="pageChange"
                                :current-page.sync="page.current"
                                :page-size="page.pageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="page.total"></el-pagination>
                </div>
            </div>
        </div>

    </div>
</template>
<style lang="scss">
.orderList-wrap {
    .show-wrap {
        .el-button--small {
            width: 86px;
            font-size: 14px;
            padding: 8px 15px;
        }
    }
    .select-btn-wrap {
        font-size: 0;
        .el-button--small {
            width: 80px;
            padding: 8px 15px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            background: #f5f5f5;
            border-color: #cccccc;
            color: #666;
        }
    }
    .option-item {
        .el-select {
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .order-tabs {
        .el-tabs__header {
            background: #f8f8f8;
            margin: 0;
            border-bottom: 1px solid #e8e8e8;
            .el-tabs__nav-wrap {
                margin-bottom: -1px;
            }
            .el-tabs__nav {
                border-radius: 0;
                height: 40px;
                .el-tabs__item {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    letter-spacing: 0;
                    text-align: center;
                    width: 170px;
                    height: 40px;
                    line-height: 38px;
                    border: none;
                    border-right: 1px solid #dbdbdb;
                }
                .is-active {
                    background: #ffffff;
                    color: #06aea6;
                    border-top: 2px solid #06aea6;
                }
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.orderlist-content-wrap {
    padding: 20px;
}
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    overflow: auto;
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.show-wrap {
    display: flex;
    justify-content: space-between;
    .search-show-wrap {
        display: flex;
    }
    .more-search {
        font-size: 0;
        color: #666;
        padding-left: 10px;
        cursor: pointer;
    }
    .more-search-text {
        font-size: 14px;
        line-height: 32px;
        padding-right: 3px;
    }
    .icon-drop_down {
        display: inline-block;
        font-size: 12px;
        color: #999;
        transition: transform 0.3s;
        transform: rotateZ(180deg);
        &.is-reverse {
            transform: rotateZ(0deg);
        }
    }
}
.hide-wrap {
    margin-top: 8px;
    background: #f7f7f7;
    border: 1px solid #e6e6e6;
    padding: 20px 0 0 20px;
}

.option-item {
    display: inline-block;
    font-size: 0;
    margin-right: 20px;
    margin-bottom: 20px;
    .label {
        padding-right: 10px;
        font-size: 14px;
        color: #666;
        display: inline-block;
        width: 56px;
        text-align: right;
    }
    &:last-child {
        margin-right: 0;
    }
}
.select-btn-wrap {
    display: inline-block;
    margin-bottom: 20px;
}
.table-wrap {
    margin-top: 20px;
    .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
            font-size: 100px;
        }
        span {
            line-height: 14px;
        }
    }
}
.circle {
    display: inline-block;
    height: 6px;
    width: 6px;
    border-radius: 3px;
    background-color: $color-warning;
    margin-right: 10px;
    &.success {
        background-color: $color-primary-second;
    }
}
.link-btn {
    cursor: pointer;
    color: $a-link;
    font-size: 12px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-right: 1px solid $a-link;
    margin-right: 6px;
    padding-right: 6px;
    &:last-child {
        border-right: none;
        margin-right: 0;
        padding-right: 0;
    }
}
</style>
<script>
import { mapGetters } from 'vuex'
import shortcuts from '@/utils/pickerOptions'
import { dateToString } from '@/utils/tools'
export default {
    name: 'orderList',
    data () {
        return {
            breadList: [{ label: '财务管理' }, { label: '订单管理' }],
            datePickerOptions: {
                shortcuts: shortcuts
            },
            isMoreShow: false,
            selectForm: {
                name: '',
                type: '',
                buyTime: [],
                startTime: '',
                endTime: '',
                status: '',
                origin: '',
                sourceTag: '',
                discountTag: ''
            },
            activeName: 'INCOME',
            statusList: [],
            statusListOut: [],
            originList: [],
            typeList: [],
            typeListTwo: [],
            page: {
                current: 1,
                total: 1,
                pageSize: 15
            },
            orderList: [],
            loading: true,
            tabList: [],
            consultFrom: []
        }
    },
    computed: {
        ...mapGetters([
            'dictionary'
        ])
    },
    methods: {
        // 导出列表数据
        formatWayJson (filterVal, jsonData) {
            return jsonData.map((v, index) => {
                return filterVal.map((j) => {
                    if (j === 'index') {
                        return (index + 1)
                    } else if (j === 'userSource') {
                        const str = this.originList.find(origin => origin.dictDataCode === v.userSource)
                            ? this.originList.find(origin => origin.dictDataCode === v.userSource).dictDataValue
                            : '-'
                        return str
                    } else if (j === 'orderType') {
                        const str = this.typeList.find(type => type.dictDataCode === v.orderType)
                            ? this.typeList.find(type => type.dictDataCode === v.orderType).dictDataValue
                            : '-'
                        return str
                    } else if (j === 'payTime') {
                        if (v.payTime) {
                            const date = new Date(v.payTime)
                            return dateToString(date, 'yyyy-MM-dd hh:mm')
                        } else {
                            return '-'
                        }
                    } else if (j === 'orderStatus') {
                        const str = this.statusList.find(status => status.dictDataCode === v.orderStatus)
                            ? this.statusList.find(status => status.dictDataCode === v.orderStatus).dictDataValue
                            : '-'
                        return str
                    } else if (j === 'userName') {
                        if (v.userName) {
                            return v.userName
                        } else {
                            return '-'
                        }
                    } else if (j === 'orderFee') {
                        if (v.orderFee) {
                            return v.orderFee
                        } else {
                            return '0'
                        }
                    } else if (j === 'divideFee') {
                        if (v.divideFee) {
                            return v.divideFee
                        } else {
                            return '0'
                        }
                    } else if (j === 'discountFee') {
                        if (v.discountFee) {
                            return v.discountFee
                        } else {
                            return '0'
                        }
                    } else if (j === 'sourceTag') {
                        if (v.sourceTag) {
                            return v.sourceTag
                        } else {
                            return '-'
                        }
                    } else if (j === 'discountTag') {
                        if (v.discountTag) {
                            return v.discountTag
                        } else {
                            return '-'
                        }
                    } else if (j === 'refundFee') {
                        if (v.refundFee) {
                            return v.refundFee
                        } else {
                            return '0'
                        }
                    } else if (j === 'productName') {
                        if (v.productName) {
                            return v.productName
                        } else {
                            return '-'
                        }
                    } else if (j === 'doctorName') {
                        if (v.doctorName) {
                            return v.doctorName
                        } else {
                            return '-'
                        }
                    } else if (j === 'deptName') {
                        if (v.deptName) {
                            return v.deptName
                        } else {
                            return '-'
                        }
                    } else if (j === 'hospitalName') {
                        if (v.hospitalName) {
                            return v.hospitalName
                        } else {
                            return '-'
                        }
                    } else if (j === 'transactionId') {
                        if (v.transactionId) {
                            return v.transactionId
                        } else {
                            return '-'
                        }
                    } else {
                        return v[j]
                    }
                })
            })
        },
        getExcel () {
            import('@/vendor/Export2Excel').then(excel => {
                let tHeader = []
                let filterVal = []
                if (this.activeName === 'INCOME') {
                    tHeader = ['序号', '订单编号', '交易流水号', '订单类型', '订单状态', '用户姓名', '用户来源', '订单来源', '优惠', '优惠金额(元)', '收入金额(元)', '订单费用(元)', '退款费用(元)', '支付时间', '来源医生', '科室', '医院']
                    filterVal = ['index', 'orderId', 'transactionId', 'orderType', 'orderStatus', 'userName', 'userSource', 'sourceTag', 'discountTag', 'discountFee', 'divideFee', 'orderFee', 'refundFee', 'payTime', 'doctorName', 'deptName', 'hospitalName']
                } else {
                    tHeader = ['序号', '订单编号', '交易流水号', '订单类型', '订单状态', '用户姓名', '用户来源', '订单费用(元)', '支付时间', '课程名称', '来源医生', '科室', '医院']
                    filterVal = ['index', 'orderId', 'transactionId', 'orderType', 'orderStatus', 'userName', 'userSource', 'orderFee', 'payTime', 'productName', 'doctorName', 'deptName', 'hospitalName']
                }
                const list = this.orderList
                if (list.length > 0) {
                    const data = this.formatWayJson(filterVal, list)
                    let filename = '订单数据'
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: filename,
                        autoWidth: true,
                        bookType: 'xlsx'
                    })
                } else {
                    this.$message({
                        message: '无数据导出！',
                        type: 'warning',
                        center: true
                    })
                }
            })
        },
        getExcelData () {
            this.page.pageSize = 1000000
            this.page.current = 1
            this.getData(this.getExcel)
        },
        handleTypeChange (value) {
            if (value) {
                this.selectForm.type = value
            } else {
                this.selectForm.type = ''
            }
        },
        handleStatusChange (value) {
            if (value) {
                this.selectForm.status = value
            } else {
                this.selectForm.status = ''
            }
        },
        handleSourceTagChange (value) {
            if (value) {
                this.selectForm.sourceTag = value
            } else {
                this.selectForm.sourceTag = ''
            }
        },
        handleOriginChange (value) {
            if (value) {
                this.selectForm.origin = value
            } else {
                this.selectForm.origin = ''
            }
        },
        handleDateChange (value) {
            if (value) {
                this.selectForm.startTime = value[0] + ' 00:00:00'
                this.selectForm.endTime = value[1] + ' 23:59:59'
            } else {
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
            }
        },
        searchOrder (type) {
            if (type === 'search') {
                this.page.current = 1
                this.getData()
            } else if (type === 'reset') {
                this.page.current = 1
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
                this.selectForm.status = ''
                this.selectForm.type = ''
                this.selectForm.name = ''
                this.selectForm.origin = ''
                this.selectForm.buyTime = []
                this.selectForm.sourceTag = ''
                this.selectForm.discountTag = ''
                this.getData()
            }
        },
        pageChange (value) {
            this.page.current = value
            this.getData()
        },
        async getData (func) {
            if (!func) {
                this.page.pageSize = 15
                this.loading = true
            }
            const param = {
                index: this.page.current,
                size: this.page.pageSize,
                start: this.selectForm.startTime,
                end: this.selectForm.endTime,
                source: this.selectForm.origin === 'all' ? '' : this.selectForm.origin,
                status: this.selectForm.status === 'all' ? '' : this.selectForm.status,
                orderType: this.selectForm.type === 'all' ? '' : this.selectForm.type,
                sourceTag: this.selectForm.sourceTag === 'all' ? '' : this.selectForm.sourceTag,
                discountTag: this.selectForm.discountTag,
                revenuetype: this.activeName,
                userName: this.selectForm.name
            }
            const { results } = await this.$services.order.getOrderList(param)
            this.orderList = results.records
            if (func) {
                func(this.orderList)
            }
            this.page.total = results.total
            this.loading = false
        },
        async getOrginType () {
            let param = {
                key: 'consult_from'
            }
            const { results } = await this.$services.order.getOrign(param)
            this.consultFrom = results || []
        },
        goDetail (item) {
            this.$router.push({
                name: 'orderDetail',
                params: {
                    orderId: item.orderId,
                    activeName: this.activeName
                }
            })
        },
        handleTabClick () {
            // 清空筛选
            this.selectForm = {
                name: '',
                type: '',
                buyTime: [],
                startTime: '',
                endTime: '',
                status: '',
                origin: ''
            }
            this.isMoreShow = false
            this.getData()
        },
        init () {
            this.originList = this.dictionary.USER_SOURCE
            this.statusList = JSON.parse(JSON.stringify(this.dictionary.ORDER_STATUS))
            this.statusListOut = JSON.parse(JSON.stringify(this.dictionary.ORDER_STATUS))
            this.statusListOut.forEach((item, key) => {
                if (item.dictDataCode === 'REFUNDED') {
                    this.statusListOut.splice(key, 1)
                }
            })
            this.typeList = this.dictionary.ORDER_TYPE
            this.tabList = this.dictionary.REVENUE_TYPE
            this.typeList.forEach(item => {
                if (item.dictDataCode !== 'EXPERT_SEMINAR') {
                    this.typeListTwo.push(item)
                }
            })
            this.getData()
            this.getOrginType()
        }
    },
    filters: {
        getDate (value) {
            if (value) {
                const date = new Date(value)
                return dateToString(date, 'yyyy-MM-dd hh:mm')
            } else {
                return '-'
            }
        },
        getScoreTag (value, consultFrom) {
            if (value) {
                let reWord = '-'
                consultFrom.forEach(item => {
                    if (item.val === value) {
                        reWord = item.valText
                    }
                })
                return reWord
            } else {
                return '-'
            }
        }
    },
    mounted () {
        this.init()
    }
}
</script>
